module.exports = __webpack_public_path__ + "static/assets/img/remote_events_3.429775d7.svg";